function TermsPage({ onBack }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary to-purple-600 px-4 py-12">
      <div className="w-full max-w-2xl">
        {/* 헤더 */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center size-16 rounded-full bg-white shadow-lg mb-4">
            <span className="material-symbols-outlined text-primary text-4xl">auto_awesome</span>
          </div>
          <h1 className="text-4xl font-black text-white mb-2">InstaAuto</h1>
        </div>

        {/* 약관 카드 */}
        <div className="bg-white dark:bg-[#111118] rounded-2xl shadow-2xl p-8 border border-slate-200 dark:border-[#282839]">
          {/* 상단 네비게이션 */}
          <div className="flex items-center justify-between mb-6">
            <button
              onClick={onBack}
              className="flex items-center gap-1 text-sm text-primary hover:underline font-medium"
            >
              <span className="material-symbols-outlined text-base">arrow_back</span>
              뒤로가기
            </button>
            <span className="text-xs text-slate-400">시행일: 2026.03.11</span>
          </div>

          <h2 className="text-2xl font-bold text-center mb-8 text-slate-900 dark:text-white">
            이용약관
          </h2>

          {/* 약관 본문 */}
          <div className="space-y-6 text-sm leading-relaxed text-slate-700 dark:text-slate-300">
            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제1조 (목적)</h3>
              <p>본 약관은 InstaAuto(이하 "서비스")의 이용 조건 및 절차, 회사와 회원 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.</p>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제2조 (용어 정의)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>"서비스"란 회사가 제공하는 인스타그램 콘텐츠 자동화 관리 플랫폼을 말합니다.</li>
                <li>"회원"이란 본 약관에 동의하고 서비스에 가입한 자를 말합니다.</li>
                <li>"계정"이란 회원이 서비스에 등록한 인스타그램 비즈니스 계정을 말합니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제3조 (서비스 내용)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>인스타그램 콘텐츠 자동 생성 및 예약 게시</li>
                <li>AI 기반 이미지 생성 및 편집</li>
                <li>DM 자동 응답 관리</li>
                <li>콘텐츠 캘린더 및 통계</li>
                <li>이미지 라이브러리 관리</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제4조 (회원가입 및 탈퇴)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>회원가입은 서비스 이용 신청 후 회사의 승낙으로 성립합니다.</li>
                <li>회원은 언제든지 탈퇴를 요청할 수 있으며, 회사는 즉시 처리합니다.</li>
                <li>탈퇴 시 회원의 데이터는 관련 법령에 따라 일정 기간 보관 후 파기합니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제5조 (회원의 권리와 의무)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>회원은 서비스를 본래의 목적에 맞게 이용하여야 합니다.</li>
                <li>회원은 타인의 개인정보를 무단으로 수집·이용할 수 없습니다.</li>
                <li>회원은 서비스를 이용하여 불법적인 활동을 하여서는 안 됩니다.</li>
                <li>회원은 계정 정보를 안전하게 관리할 책임이 있습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제6조 (서비스 제공 및 변경)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>회사는 연중무휴, 24시간 서비스를 제공함을 원칙으로 합니다.</li>
                <li>회사는 서비스 개선을 위해 사전 공지 후 서비스 내용을 변경할 수 있습니다.</li>
                <li>시스템 점검, 업데이트 등으로 일시적 서비스 중단이 발생할 수 있습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제7조 (서비스 이용 제한)</h3>
              <p className="mb-2">회사는 다음의 경우 서비스 이용을 제한할 수 있습니다:</p>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>타인의 명의를 도용한 경우</li>
                <li>서비스 운영을 방해하는 행위를 한 경우</li>
                <li>관련 법령을 위반한 경우</li>
              </ul>
              <p className="mt-2">이용 제한 시 회사는 사전에 사유를 통보합니다.</p>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제8조 (지식재산권)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>서비스에 관한 지식재산권은 회사에 귀속됩니다.</li>
                <li>회원이 서비스를 통해 생성한 콘텐츠의 저작권은 회원에게 있습니다.</li>
                <li>회원은 회사의 사전 동의 없이 서비스를 복제·배포할 수 없습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제9조 (면책조항)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>회사는 천재지변 또는 불가항력적 사유로 인한 서비스 중단에 책임을 지지 않습니다.</li>
                <li>회사는 회원의 귀책사유로 인한 서비스 이용 장애에 책임을 지지 않습니다.</li>
                <li>인스타그램 API 정책 변경으로 인한 기능 제한에 대해 회사는 책임을 지지 않습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base text-slate-900 dark:text-white mb-2">제10조 (분쟁해결)</h3>
              <ol className="list-decimal list-inside space-y-1">
                <li>서비스 이용과 관련하여 분쟁이 발생한 경우 양 당사자는 원만한 해결을 위해 노력합니다.</li>
                <li>본 약관에 관한 소송은 회사의 본사 소재지 관할 법원을 전속 관할로 합니다.</li>
              </ol>
            </section>

            <section className="pt-4 border-t border-slate-200 dark:border-[#282839]">
              <p className="font-semibold text-slate-900 dark:text-white">부칙</p>
              <p>본 약관은 2026년 3월 11일부터 시행합니다.</p>
            </section>
          </div>
        </div>

        {/* 저작권 */}
        <div className="text-center mt-6">
          <p className="text-white/60 text-sm">&copy; 2024 InstaAuto. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
